import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import React from 'react';
import {
  CalculatePriceForm,
  CalculatePriceFormSubmission,
} from 'components/ProductForm/CalculatePriceForm';
import {ISupplierUserProfile} from 'constants/interfaces';

export function CalculatePriceDialog(props: {
  user: ISupplierUserProfile;
  open: boolean;
  onClose: VoidFunction;
  onSubmit: (submission: CalculatePriceFormSubmission) => any;
}) {
  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      className="update-password-dialog"
    >
      <DialogTitle>Calculate Price</DialogTitle>
      <DialogContent>
        <CalculatePriceForm
          user={props.user}
          cancelButtonTitle="Cancel"
          onCancel={props.onClose}
          submitButtonTitle="Submit"
          onSubmit={props.onSubmit}
        />
      </DialogContent>
    </Dialog>
  );
}
